<template>
  <div class="project-user-assignement ">
    <assignment-modal
      :collection="filteredUsers"
      :assignedCollection="assignedUsersList"
      :title="computedTitle"
      :subtitle="computedSubtitle"
      :open="isOpen"
      searchPlaceholder="users"
      displayName="display_name"
      @close="close"
      @save="save"
    />
    <div v-if="this.assignedUsers.length === 0" class="empty-state-assignment">
      <img src="../../../assets/collaborators.svg">
      <p>{{$t('ui.pages.project-no-assigned-user')}}</p>
      <div class="actions">
        <span
          class="btn btn-primary"
          @click="isOpen = true"
        >
          {{$t('ui.pages.project-assign-user')}}
        </span>
      </div>
    </div>

    <div v-if="this.assignedUsers.length > 0" class="project-user-assignement--monitor">
      <h3>
        {{$t('ui.pages.project-assigned-user')}}:
      </h3>
        <a
          class="link"
          @click="isOpen = true"
        >
          {{$t('ui.pages.project-assign-user')}}
        </a>
      <div
        v-for="user in assignedUsersList"
        :key="user.id"
        class="user"
      >
        <div class="box">
          <div class="user-name">
            <div class="circle">
              <span v-if="user.firstname && user.lastname" class="initials">{{`${user.firstname.charAt(0)}${user.lastname.charAt(0)}`}}</span>
              <span v-else class="initials">?</span>
            </div>
            <div>
              <span v-if="user.firstname && user.lastname">{{ `${user.firstname} ${user.lastname}` }}</span>
                <span v-else></span>
              <p class="caption">{{ user.email }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AssignmentModal from '@/components/layouts/partials/AssignmentModal'

export default{
  props: {
    users: {
      type: Array
    },
    assignedUsers: {
      type: Array
    }
  },
  components: {
    AssignmentModal
  },
  computed: {
    computedTitle() {
      return "user_assignment.title"
    },
    computedSubtitle() {
      return "user_assignment.subtitle"
    },
    assignedUsersList() {
      let assignedUsers = this.assignedUsers
      return this.users.filter((user) => {
        return assignedUsers.includes(user.id)
      })
    },
    filteredUsers() {
      // Put assigned at the top
      let c = this.users.filter(item => !this.assignedUsersList.includes(item))
      // Merge both collections together in correct order
      let filteredUsers = [...this.assignedUsersList, ...c]
      // If user has no name put their email as the display_name
      filteredUsers.forEach((item) => {
        if (!item.display_name || item.display_name === '') {
          item.display_name = item.email
        }
      })
      return filteredUsers
    }
  },
  data(){
    return {
      isOpen: false
    }
  },
  methods: {
    save(items) {
      let assignedUsers= items.map(item => item.id)
      this.close()
      this.$emit('update', assignedUsers)
    },
    close() {
      this.isOpen = false
    }
  },
}
</script>
<style lang="sass" scoped>
.btn
  padding: 6px 15px

.user
  margin-bottom: 10px
  &:first-of-type
    margin-top: 20px

  p
    margin-bottom: 0

.empty-state-assignment
  text-align: center
  p
    color: $ink-lighter
    margin-top: 20px
.actions
  margin-top: 20px

.project-user-assignement--monitor
  h3
    font-size: 20px
    margin-bottom: 10px
    margin-top: 0
  a
    font-weight: 500
    cursor: pointer

.box
  background-color: $paper-lighter
  border-radius: 5px
  padding: 17px
  max-width: 300px
  .user-name
    margin-bottom: 0
    margin-top: 0
    font-size: 14px !important
    color: $ink-light
    font-weight: 500 !important
    line-height: 20px !important
    display: flex

  p
    margin-top: 0px
.circle
  background-color: $sensual-lighter
  border-radius: 50%
  height: 32px
  text-align: center
  width: 32px
  display: inline-block
  margin-top: 0
  margin-right: 15px

  .initials
    font-size: 16px
    font-weight: $font-medium
    background: $sensual-lighter
    color: $sensual
    line-height: 32px
    position: relative

</style>



// WEBPACK FOOTER //
// ProjectUserAssignement.vue?045967d3